import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, DetailsSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemTablet: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const topInfos = [
    {
      label: 'Tipo Oferta',
      value: (
        <HStack space={Spacing['inline.quarck']} alignItems="center">
          <DetailsSkeleton />
          <TextSkeleton w="60%" />
        </HStack>
      ),
      maxW: '19%',
    },
    { label: 'Empresa', value: <TextSkeleton w="60%" />, maxW: '19%' },
    { label: 'Nome', value: <TextSkeleton w="60%" />, maxW: '19%' },
    { label: 'Cód. Isin', value: <TextSkeleton w="60%" />, maxW: '19%' },
    { label: 'Alteração', value: <TextSkeleton w="60%" />, maxW: '19%' },
  ];

  const bottomInfos = [
    { label: 'Negociação', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Liquidação', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Limitador', value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" w="20%">
            <ButtonSkeleton />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
